exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (max-width: 600px){.mobile[data-v-4941673d]{margin-left:58px}}\n", ""]);

// exports
